export default __webpack_public_path__ + "static/fingerprint-21cb32f5a4abf6a687d6ad6d98701b47.svg";